// removed by extract-text-webpack-plugin
module.exports = {"container":"_35XqFMUkUyTEl5y_YBhSSx","row":"jG0vPhL2slXO6mL2I6yX0","EthereumAddressInputField":"_2maddMQxlwbpNy9brDmtJS"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/EthereumAddressInputField.scss
// module id = 1281
// module chunks = 0